import React from 'react'

import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { LazyLoadImage } from "react-lazy-load-image-component";
const InfoSection = ({DesktopLeftImg, MobileLeftImg, OverLine, Heading, Para, Url}) => {
  return (
    <>
        <div className="about_lgrown">
            <Container fluid>
                <Row>
                    <Col md={6} className='p-0'>
                        <div className="left_bx">
                            <LazyLoadImage className="d-md-block d-none" src={DesktopLeftImg} alt="About Lab Grown Diamond" />
                            <LazyLoadImage className="d-md-none d-block" src={MobileLeftImg} alt="About Lab Grown Diamond Mobile" />
                        </div>
                    </Col>

                    <Col md={6} className='align-self-center p-0'>
                        <div className="right_bx">
                            <div className="inner_right_bx">
                                <p className="overline">{OverLine}</p>
                                <h2 className="red-underline">{Heading}</h2>
                                <p className="txt_body">{Para}</p>
                                <p className="txt_link m-0"><Link to={Url}>Shop Now</Link></p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </>
  )
}

export default InfoSection